<mat-tab-group (selectedTabChange)="onTabChanged($event)">
    <mat-tab *ngIf="isTR" label="Transfer">
        <h3>Transfer: {{repWarehouse}}</h3>

        <mat-form-field appearance="fill" style="width:100%;">
            <mat-label>Transfer Order Description</mat-label>
            <input matInput [(ngModel)]="order.Description" />
        </mat-form-field>
    </mat-tab>

    <mat-tab *ngIf="isSO" label="Order">
        <div>
            <customer-selector [expand]="['Locations','PrimaryContact']" [(ngModel)]="customer"
                (onChange)="onCustomerChanged($event)">
            </customer-selector>

            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Customer Location</mat-label>
                <mat-select [(ngModel)]="customerLocation" name="customerLocation">
                    <mat-option *ngFor="let loc of customerActiveLocations()" [value]="loc">
                        <div class="customerLocation">
                            {{loc.LocationID}} - {{loc.LocationName}}<br />
                            {{loc.AddressLine1}}<br />
                            {{loc.City}}, {{loc.State}} {{loc.PostalCode}}
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Customer Order / Project #</mat-label>
                <input matInput [(ngModel)]="order.CustomerOrderNbr" maxlength="40" />
            </mat-form-field>

            <mat-form-field appearance="fill" style="width:100%;" maxlength="200">
                <mat-label>Order Description</mat-label>
                <input matInput [(ngModel)]="order.Description" />
            </mat-form-field>

            <mat-form-field appearance="fill" style="width:100%;" maxlength="60">
                <mat-label>Project Name</mat-label>
                <input matInput [(ngModel)]="projectName" />
            </mat-form-field>

            <mat-form-field appearance="fill" style="width:100%;" maxlength="30">
                <mat-label>Project Location</mat-label>
                <input matInput [(ngModel)]="projectLocation" />
            </mat-form-field>

            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Ship Via</mat-label>
                <!-- <mat-select [(value)]="order.ShipVia"> -->
                <mat-select (selectionChange)="updateShipVia($event)" [value]="shipVia.ID">
                    <mat-option *ngFor="let shipVia of shipVias"
                        [value]="shipVia.ID">{{shipVia.Description}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field #CustomerShipperNbrField appearance="fill" style="width:100%;" maxlength="20">
                <mat-label>Customer UPS/FedEx Shipper #</mat-label>
                <input matInput [(ngModel)]="order.ShipperUPSFedExNbr" />
            </mat-form-field>

            <!-- <div style="margin: 0.25em 0;">Ship To:</div> -->
            <mat-button-toggle-group style="width:99%; margin-bottom:5px;" [value]="shipTo"
                (change)="shipTo = $event.value">
                <mat-button-toggle style="width:50%;" [value]="RepOrderShipToEnum.Customer">Ship directly to Customer
                </mat-button-toggle>
                <mat-button-toggle style="width:50%;" [value]="RepOrderShipToEnum.SalesRep">Ship to Me - I'll Deliver
                </mat-button-toggle>
            </mat-button-toggle-group>

            <div *ngIf="shipTo == RepOrderShipToEnum.Customer">
                <so-shipto-input [order]="order" [customer]="customer"></so-shipto-input>
            </div>
        </div>
    </mat-tab>

    <mat-tab label="Items">
        <inventory-id-selector #itemSelector (onSubmit)="barcodeValidation($event)"
            (onChange)="processScannedBarcode($event)" [search]="true" [searchWhse]="'03'"
            [searchValidator]="searchValidator"></inventory-id-selector>

        <!-- <mat-tree [dataSource]="catalogDataSource" [treeControl]="treeControl"
                style="display:flex; flex-direction:row; flex-wrap: wrap;"> -->
        <mat-tree [dataSource]="catalogDataSource" [treeControl]="treeControl">

            <!-- This is the tree node template for specific items -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="10">
                <rep-order-item #repOrderItem [item]="node.item" [qty]="cartItem(node.inventoryID)?.qty"
                    [viewMode]="ItemViewMode" (onQtyChange)="updateCartQuantity(node, $event)"
                    (onNonNumericInput)="checkForQRScan($event)"
                    [style.width]="displayAsList ? '100%' : 'auto'"></rep-order-item>
            </mat-tree-node>

            <!-- This is the tree node template for itemsets -- buttons that add multiple items in one click -->
            <mat-tree-node *matTreeNodeDef="let node; when: isItemSet" matTreeNodePadding matTreeNodePaddingIndent="10">
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <span>
                    {{node.description}}
                </span>
                <span style="margin-left:auto;"></span>
                <button mat-raised-button color="accent" [style.width.em]="11"
                    (click)="addItemSetToCart(node.itemset)">Add {{node.itemset.length}}
                    items</button>
            </mat-tree-node>

            <!-- This is the tree node template for expandable nodes (section/group headers) -->
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20"
                (click)="toggleNode(node)" style="flex:none; width:100%;">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </button>
                {{node.description}}
            </mat-tree-node>
        </mat-tree>
    </mat-tab>

    <mat-tab [label]="'Review (' + cartCount + ')'">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <td>Inventory ID</td>
                    <td>Description</td>
                    <td>Qty</td>
                    <td><!-- line item menu --></td>
                </tr>
            </thead>
            <tbody *ngFor="let entry of cart">
                <tr>
                    <td rowspan="4" style="vertical-align:top;">
                        <mat-chip-list>
                            <mat-chip [style.backgroundColor]="LifeCycleColor(entry.item.LifeCycle || 'inherited')"
                                [style.color]="LifeCycleContrastColor(entry.item.LifeCycle || 'inherited')"
                                class="inventory-id-chip">
                                {{entry.item.InventoryID}}
                            </mat-chip>
                        </mat-chip-list>
                    </td>
                    <td>{{entry.item.ItemDescription}}</td>
                    <td>{{entry?.qty}}</td>
                    <td>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="removeFromCart(entry.item.InventoryID)">
                                <mat-icon>remove_shopping_cart</mat-icon>
                                <span>Remove from cart</span>
                            </button>
                        </mat-menu>
                    </td>
                </tr>
                <tr *ngIf="itemInventory[entry.item.InventoryID]?.Mayer != undefined && itemInventory[entry.item.InventoryID]!.Mayer! < 20">
                    <!-- <td></td> -->
                    <td colspan="3">
                        <mat-icon>{{itemInventory[entry.item.InventoryID]?.Mayer == 0 ? 'report' : 'warning'}}</mat-icon>
                        Mayer Warehouse inventory is {{itemInventory[entry.item.InventoryID]?.Mayer! <= 0 ? 'Empty' : 'low' }} </td>
                </tr>
                <tr class="checking-inventory-progress" *ngIf="itemInventory[entry.item.InventoryID] == null">
                    <!-- <td></td> -->
                    <td colspan="3">
                        <mat-spinner diameter="24"></mat-spinner>Checking Inventory...
                    </td>
                </tr>
                <tr *ngIf="isSO && itemInSalesRepInventory(entry.item.InventoryID) >= entry.qty">
                    <!-- <td></td> -->
                    <td colspan="3" *ngIf="itemInventory[entry.item.InventoryID]?.SalesRep !== undefined">
                        <mat-slide-toggle (change)="toggleRepSupply(entry.item.InventoryID, $event)"
                            [checked]="entry.warehouseID == repWarehouse">My Supply
                            <span *ngIf="itemInventory[entry.item.InventoryID] !== null"> ({{itemInventory[entry.item.InventoryID]?.SalesRep}})</span></mat-slide-toggle>
                    </td>
                </tr>
            </tbody>
        </table>

        <div style="display:flex; padding: 0.25em; margin-top: 0.5em;">
            <button *ngIf="isSO && cartItemsInSalesRepInventory().length > 0" mat-raised-button
                (click)="fillAllFromRepInventory()">Fill all possible items from My
                Supply</button>
            <span style="margin-left:auto;"></span>
            <button mat-raised-button color="primary"
                [disabled]="cartCount == 0 || gettingInventories > 0 || gettingStockItems > 0"
                (click)="placeOrder()">Submit
                Order</button>
        </div>
    </mat-tab>
</mat-tab-group>